import CustomStore from 'devextreme/data/custom_store';
import { reactive, ref } from 'vue';
import useInvoiceFrequencyRepository from '@/modules/masterData/invoiceFrequency/repositories/invoice-frequency.repository.js';
import store from '@/store/index';

export default function useDatagrid() {
  const mainInvoiceFrequencyRepository = useInvoiceFrequencyRepository();
  const datasource = ref();
  const invoiceFrequencyList = reactive({ data: null });

  const getDatasource = () => {
    datasource.value = new CustomStore({
      key: 'id',
      load: (loadOptions) => mainInvoiceFrequencyRepository.load(loadOptions)
        .then((response) => {
          invoiceFrequencyList.data = response.data;
          return {
            data: response.data.data,
            totalCount: response.data.totalCount,
            summary: response.data.summary,
            groupCount: response.data.groupCount,
          };
        }),
      update: (key, values) => new Promise((resolve, reject) => {
        mainInvoiceFrequencyRepository.update(key, values)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Dine ændringer er gemt');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
      insert: (values) => new Promise((resolve, reject) => {
        mainInvoiceFrequencyRepository.insert(values)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Faktureringsfrekvens er nu oprettet');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
      remove: (key) => new Promise((resolve, reject) => {
        mainInvoiceFrequencyRepository.remove(key)
          .then((response) => {
            if (response.data.success) {
              store.dispatch('addSuccessNotification', 'Faktureringsfrekvens er nu slettet');
              resolve(response);
            } else {
              if (response.data.messages.length > 0) {
                store.dispatch('addNotifications', { messageList: response.data.messages });
              }
              reject();
            }
          });
      }),
    });
  };

  return {
    datasource,
    getDatasource,
    invoiceFrequencyList,
  };
}
